import React, { Component } from 'react';
import AudioJoinerFooterRender from './children/AudioJoinerFooterRender';
import Utils from '@/utils';

import '@/assets/audioJoiner.less';

class AudioJoinerFooterFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      format: 'mp3',
    };
  }

  handleFormatChange = (value) => {
    this.setState({
      format: value,
    });
  };

  render() {
    return (
      <AudioJoinerFooterRender
        handleSubmit={() => {
          let flag = Utils.handleVideoEditorTimes('27AM');
          if (flag) {
            return false;
          }
          this.props.handleSubmit(this.state.format);
        }}
        format={this.state.format}
        handleFormatChange={this.handleFormatChange}
      />
    );
  }
}

export default AudioJoinerFooterFunction;
